import styled from "styled-components";

import { theme } from "theme/theme";

export const WrapperConfirmForm = styled.div`
  text-align: center;
  padding: 24px 21px 32px;
`;

export const CompanyName = styled.div`
  font-family: Noto Sans JP;
  font-size: 18px;
  font-weight: 700;
  line-height: 26px;
  letter-spacing: 0px;
  text-align: center;
  color: ${theme.colors.textLink};
  margin-bottom: 24px;
`;

export const Question = styled.div`
  font-family: Noto Sans JP;
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: 0px;
  text-align: center;
  color: ${theme.colors.text.primary};
`;

export const GroupButton = styled.div`
  display: flex;
  gap: 24px;
  justify-content: center;

  button {
    width: 128px;
    height: 40px;
  }
`;

export const WrapperSelectLanguage = styled.div`
  padding: 13px 38px 16px;
  margin-bottom: 16px;
  background: ${theme.colors.background};
  border-radius: 4px;
  display: flex;
  gap: 8px;
  flex-direction: column;

  > div {
    font-family: Noto Sans JP;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0px;
    text-align: left;
    color: ${theme.colors.text.primary};
  }

  ${theme.media.tablet} {
    padding: 8px 28px;
    flex-direction: row;
    align-items: center;
  }
`;

export const AudioWrapper = styled.div`
  flex: 1;
  display: flex;
  gap: 12px 16px;
  flex-wrap: wrap;
  .ant-radio-wrapper {
    height: max-content;
    align-items: center !important;
    display: flex;
    margin-right: 0px !important;
    margin-left: 2px;
  }
  .ant-radio-wrapper::after {
    display: none;
  }
  .ant-radio-wrapper > span:not(.ant-radio) {
    font-weight: 400;
    font-size: 14px;
    line-height: 14px;
    padding-left: 6px;
    padding-right: 0;
  }
  .ant-radio {
    top: 0 !important;
  }
  .ant-radio-inner {
    border: 2px solid #cccccc;
    width: 20px;
    height: 20px;
  }
  .ant-radio-checked .ant-radio-inner {
    border: 2px solid #cccccc;
    width: 20px;
    height: 20px;
  }
  .ant-radio-inner::after {
    background-color: #2ac769;
    top: calc(50% - 6.5px);
    left: calc(50% - 6.5px);
    width: 13px;
    height: 13px;
  }
  .ant-radio:hover .ant-radio-inner,
  .ant-radio:hover .ant-radio-checked .ant-radio-inner {
    border-color: #cccccc;
  }
`;

export const TextRadio = styled.div`
  font-family: Noto Sans JP;
  font-size: 16px;
  font-weight: 500;
  line-height: 23px;
  letter-spacing: 0px;
  text-align: left;
  color: ${theme.colors.text.primary};
`;

export const Label = styled.div`
  font-family: Noto Sans JP;
  font-size: 14px;
  font-weight: 500;
  line-height: 14px;
  letter-spacing: 0em;
  text-align: left;
  color: ${theme.colors.text.primary};
  margin-bottom: 8px;
`;

export const WrapperCreateForm = styled.div`
  padding: 24px 16px 32px;

  ${theme.media.tablet} {
    padding: 24px 40px 32px;
  }
`;
